var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('nyd-navbar',{attrs:{"type":_vm.mode}}),_c('router-view'),[_c('nyd-footer',{attrs:{"visible":_vm.mode === 'screen' ? true : false}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }